import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'timeTransform'
})
export class TimeTransformPipe implements PipeTransform {
  transform(value: string): Date | null {
    if (value !== null) {
      const [hours, minutes] = value.split(':').map(Number);
      const date = new Date();
      date.setHours(hours, minutes, 0, 0);
      return date;
    } else {
      return null;
    }
  }
}
